class TabIDConstant{
    // TABS
    static HOME_TAB = 1;
    static LOCATIONS_TAB = 2;
    static USERS_TAB = 3;
    static PH_SYSTEM_TAB = 4;
    static ADMIN_TOOLS_TAB = 5;
    static BILLING_TAB = 6;
    static ANALYTICS_TAB = 7;
    
    // LINKS
    // LOCATIONS TAB LINKS
    static LOCATIONS_LINK = 8;

    // USERS TAB LINKS
    static USERS_LINK = 33;
    static STREAMS_TEAMS_LINK = 34;
    static PERM_ROLES_LINK = 35;
    static MS_ENTRA_LINK = 151

    // PHONE SYSTEM LINKS
    static PH_NUMS_LINK = 54;
    static CALL_FLOWS_LINK = 55;
    static LUNA_AI_LINK = 56;
    static SPAM_AND_BLOCK_LINK = 57;
    static AUTO_ATTENDANT_LINK = 58;
    static HUNT_GRP_LINK = 59;
    static FAX_GRP_LINK = 60;
    static DEVICES_LINK = 61;
    static MEDIA_LIB_LINK = 62;
    static DIAL_BY_NAME_DIR_LINK = 63;
    static GLOBAL_SETT_LINK = 64;
    static SMS_GRPS_LINK = 65;
    static REPUTATION_LINK = 154;
    static SMS_REGISTRATION_LINK = 161;

    // ADMIN TOOLS LINKS
    static ACC_INFO_LINK = 119;
    static ACC_SETTINGS_LINK = 120;
    static CONTACTS_LINK = 121;
    static ORG_GRPS_LINK = 122;
    static STREAMS_SETTINGS_LINK = 123;
    static SECURITY_LINK = 124;
    static API_LINK = 157;

    // BILLING LINKS
    static OVERVIEW_LINK = 140;
    static BILLING_GRPS_LINK = 141;
    static BILLING_ACC_INFO_LINK = 142;


    // SUB LINKS

    // SUB LINKS OF LOCATIONS LINKS IN LOCATIONS TAB
    static LOC_SUBLINK = 9;
    static LOC_MAP_SUBLINK = 10;


    // SUB LINKS OF USERS LINK IN USERS TAB
    static USERS_SUBLINK = 36;
    static USER_GRPS_SUBLINK = 37;

    // SUB LINKS FOR MS ENTRA INTEGRATION LINK IN USERS TAB
    static USR_PROVISIONING_SUBLINK = 152;
    static SINGLE_SIGN_ON_SUBLINK = 153;

    // SUB LINKS FOR PHONE NUMBERS LINK IN PHONE SYSTEM TAB 
    static ASSIGNED_PH_NUM_SUBLINK = 66;
    static UNASSIGNED_PH_NUM_SUBLINK = 67;
    static VALIDATED_PH_NUM_SUBLINK = 68;
    static NUM_PORTING_SUBLINK = 69;
    static TN_TFN_PORT_BTN_SUBLINK = 72;

    // SUB LINKS FOR REPUTATION LINK IN PHONE SYSTEM TAB
    static MONITORING_LINK = 155;

    // SUB LINKS FOR SPAM & BLOCKING LINK IN PHONE SYSTEM TAB
    static PERMITTED_SUBLINK = 81;
    static BLOCKED_SUBLINK = 82;

    // SUB LINKS FOR DEVICES LINK IN PHONE SYSTEM TAB
    static DEVICES_SUBLINK = 94;
    static ONLINE_DEVICE_MAP_SUBLINK = 95;
    static BLF_GRPS_SUBLINK = 96;
    static PAGING_GRPS_SUBLINK = 97;

    // SUB LINKS FOR MEDIA LIBRARY LINK IN PHONE SYSTEM TAB
    static SOUND_CLIPS_SUBLINK = 110;
    
    // SUB LINKS FOR GLOBAL SETTINGS LINK IN PHONE SYSTEM TAB
    static GLOBAL_SETT_SETTINGS_SUBLINK = 115;

    //SUB LINKS FOR SMS REGISTRATION LINK IN PHONE SYSTEM TAB
    static SMS_BRANDS_SUBLINK = 162;
    static SMS_CAMPAIGNS_SUBLINK = 163;
    static SMS_DRAFTS_SUBLINK = 164;

    // SUB LINKS FOR ACCOUNT INFORMATION LINK IN ADMIN TOOLS TAB
    static ACC_INFO_SETTINGS_SUBLINK = 125;

    // SUB LINKS FOR ACCOUNT SETTINGS LINK IN ADMIN TOOLS TAB
    static ACC_SETT_SETTINGS_SUBLINK = 126;

    // SUB LINKS FOR API'S LINK IN ADMIN TOOLS TAB
    static STREAMS_API_APPS_SUBLINK = 158;
    
    // SUB LINKS FOR CONTACTS LINK IN ADMIN TOOLS TAB
    static CONTACTS_SUBLINK = 127;
    static CORP_CONTACTS_SUBLINK = 128;
    static MNG_CUST_FIELDS_SUBLINK = 129;
    static IMP_GLOBAL_CONTACTS_SUBLINK = 160;

    // SUB LINKS FOR ORG GROUPS LINK IN ADMIN TOOLS TAB
    static ORGANIZATIONS_SUBLINK = 132;
    static ORG_POOLS_SUBLINK = 133;

    // SUB LINKS FOR STREAMS SETTINGS LINK IN ADMIN TOOLS TAB
    static STREAMS_SETT_SUBLINK = 137;

    // SUB LINKS FOR SECURITY LINK IN ADMIN TOOLS TAB
    static SECURITY_SETT_SUBLINK = 138;
    static TRUSTED_IP_SUBLINK = 139;

    // SUB LINKS FOR BILLING ACCOUNT INFO LINK IN BILLING TAB
    static BILL_ACC_INFO_SUBLINK = 149;
    static BILL_STMT_SUM_SUBLINK = 150;

}

export default TabIDConstant;